import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BoxIcon } from 'lucide-react';
interface CaseStudyCardProps {
  id: string;
  title: string;
  description: string;
  metrics: string[];
  skills: string[];
  icon: BoxIcon;
  iconColor?: string;
  iconBgColor?: string;
}
export function CaseStudyCard({
  id,
  title,
  description,
  metrics,
  skills,
  icon: Icon,
  iconColor = '#0096B4',
  iconBgColor = '#E0F5F8'
}: CaseStudyCardProps) {
  return <div className="bg-white rounded-lg shadow-md overflow-hidden transition-transform duration-300 hover:shadow-lg hover:-translate-y-1" data-id="element-42">
      <div className="h-48 flex items-center justify-center" style={{
      backgroundColor: iconBgColor
    }} data-id="element-43">
        <Icon size={80} color={iconColor} strokeWidth={1.5} data-id="element-44" />
      </div>
      <div className="p-6" data-id="element-45">
        <h3 className="text-xl font-semibold mb-3 text-gray-800" data-id="element-46">{title}</h3>
        <p className="text-gray-600 mb-4" data-id="element-47">{description}</p>
        <div className="mb-4" data-id="element-48">
          {metrics.map((metric, index) => <div key={index} className="flex items-center mb-2" data-id="element-49">
              <div className="w-2 h-2 rounded-full bg-[#0096B4] mr-2" data-id="element-50"></div>
              <span className="text-sm text-gray-700" data-id="element-51">{metric}</span>
            </div>)}
        </div>
        <div className="flex flex-wrap gap-2 mb-5" data-id="element-52">
          {skills.map((skill, index) => <span key={index} className="bg-[#E0F5F8] text-[#0096B4] px-3 py-1 rounded-full text-xs font-medium" data-id="element-53">
              {skill}
            </span>)}
        </div>
        <Link to={`/case-study-${id}`} className="inline-flex items-center text-[#0096B4] font-medium hover:text-[#00778F] transition-colors duration-200" data-id="element-54">
          View Case Study
          <ArrowRightIcon size={16} className="ml-1" data-id="element-55" />
        </Link>
      </div>
    </div>;
}